import script from "./NumberListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberListSort.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__